export const DEFAULT_DATE_TIME_BLOCK_HEIGHT = 24;
export const DEFAULT_BOTTOM_PADDING = 90;
